import React from 'react';
import { Key } from 'lucide-react';
import { SiteData } from '../types/data';

interface FooterProps {
  data: SiteData['footer'];
  title: string;
  subtitle: string;
}

export const Footer = ({ data, title, subtitle }: FooterProps) => {
  return (
    <footer className="bg-slate-950 text-gray-400 py-12 border-t border-slate-900">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-2">
            <div className="bg-primary p-1.5 rounded-lg">
              <Key className="w-5 h-5 text-white" />
            </div>
            <span className="text-xl font-bold text-white">
              {title}<span className="text-primary">{subtitle}</span>
            </span>
          </div>

          <div className="text-sm text-center leading-relaxed">
            <p className="text-gray-300">{data.business.name} &mdash; IČO: {data.business.ico}</p>
            <p>{data.business.address}</p>
            <p>{data.business.vatNote}</p>
          </div>

          <div className="text-sm">
            &copy; {new Date().getFullYear()} {data.copyright}
          </div>
        </div>
      </div>
    </footer>
  );
};
